import React from "react";
import BulkDeleteConfig from "../../components/FeatureConfig/BulkDeleteConfig";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureConfigBulkUploadActions from "../../store/actions/FeatureConfig";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  "Delete global config only if it has been removed from application as well. For global config, entity and entity id should be empty.",
];

const FeatureConfigBulkDeleteDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkDeleteConfig
      instructions={instructions}
      btnDataTestID="FeatureConfigBulkDeleteBtn"
      uploadUrl="/feature-config/bulk-update"
      sampleURL="/sample/bulk_delete_feature_config.csv"
      id="FeatureConfigBulkDeleteModal"
      sendExtraAck={true}
      keyName="callback"
      heading="Bulk Delete Feature Config"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      FeatureConfigBulkUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(FeatureConfigBulkDeleteDashboard);
